import { CanDeactivateGuard } from '@shared/directives';
import { TranslateStore } from '@ngx-translate/core';
import { CommonModule, DatePipe } from '@angular/common';
import {
    ApiService,
    CacheService,
    ConfigService,
    DialogService,
    ExportService,
    FaqService,
    FileService,
    GlossaryService,
    GuardService,
    HyperlinkService,
    LocalService,
    MailingService,
    ReportService,
    ReportTemplateService,
    ResponsibleService,
    SCDService,
    SnackService,
    SummaryReportService,
    UserService,
    ContactService
} from '@shared/services';
import { ReportBuilderService } from '@app/main/report/services/report-builder.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ComponentsModule } from '@shared/components/components.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleActiveGuard } from '@shared/services/module-active.guard';
import { ModuleService } from '@shared/services/module.service';
import { AdminAuthGuard } from '@app/auth/services/admin-auth.guard';

const components = [];

const modules = [ComponentsModule];

@NgModule({
    declarations: [components],
    exports: [...modules],
    imports: [CommonModule, ...modules],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                UserService,
                ApiService,
                LocalService,
                SCDService,
                SnackService,
                GlossaryService,
                HyperlinkService,
                ReportTemplateService,
                ReportService,
                ResponsibleService,
                GuardService,
                DialogService,
                TranslateStore,
                FileService,
                SummaryReportService,
                ConfigService,
                CacheService,
                ReportBuilderService,
                FaqService,
                ExportService,
                DatePipe,
                CanDeactivateGuard,
                MailingService,
                ModuleActiveGuard,
                ModuleService,
                ContactService,
                AdminAuthGuard
            ]
        };
    }
}
